import React from 'react';
import InteractiveTooltip from './InteractiveTooltip';

interface Signal {
  id: number;
  pair: string;
  type: string;
  direction: 'up' | 'down';
  entryTime: string;
  duration: string;
  forecast: number;
  payout: number;
}

const SignalCard: React.FC<{ signal: Signal }> = ({ signal }) => {
  const isUp = signal.direction === 'up';

  return (
    <div className="bg-gradient-to-br from-[#1b3a39] to-[#142b2a] border border-[#34d399]/20 rounded-lg p-2.5 sm:p-3 shadow-[0_0_10px_rgba(52,211,153,0.05)] backdrop-blur-md transition-transform duration-300 hover:scale-[1.03]">
      
      {/* اسم الزوج */}
      <InteractiveTooltip
        explanation="هذا هو اسم زوج العملات ونوعه (خارج البورصة)"
        className="w-full"
      >
        <h3 className="text-base sm:text-lg font-bold text-yellow-300 tracking-wider text-center mb-2">
          {signal.pair} - {signal.type}
        </h3>
      </InteractiveTooltip>

      {/* تفاصيل الصفقة */}
      <div className="grid grid-cols-3 text-center items-start">
        <div className="flex flex-col items-center">
          <p className="text-[11px] sm:text-xs text-gray-400 mb-1">الاتجاه</p>
          <InteractiveTooltip explanation="هذا هو اتجاه الصفقة المتوقع (شراء أو بيع)">
            <i
              className={`bx ${
                isUp ? 'bx-up-arrow-alt' : 'bx-down-arrow-alt'
              } text-3xl sm:text-4xl ${
                isUp ? 'text-green-400' : 'text-red-400'
              }`}
            ></i>
          </InteractiveTooltip>
        </div>

        <div className="flex flex-col items-center">
          <p className="text-[11px] sm:text-xs text-gray-400 mb-1">وقت الدخول</p>
          <InteractiveTooltip explanation="هذا هو الوقت المثالي لدخول الصفقة">
            <p className="text-xl sm:text-2xl font-bold text-cyan-300 font-mono">
              {signal.entryTime}
            </p>
          </InteractiveTooltip>
        </div>

        <div className="flex flex-col items-center">
          <p className="text-[11px] sm:text-xs text-gray-400 mb-1">المده</p>
          <InteractiveTooltip explanation="هذه هي مدة صلاحية الصفقة بالدقائق">
            <p className="text-xl sm:text-2xl font-bold text-cyan-300 font-mono">
              {signal.duration}
            </p>
          </InteractiveTooltip>
        </div>
      </div>

      {/* نسبة النجاح والربح */}
      <div className="border-t border-gray-600/30 mt-2 pt-2 flex justify-around text-gray-300 text-[11px] sm:text-xs">
        <InteractiveTooltip
          explanation="قوة التوصية: نسبة نجاحها المتوقعة"
          className="flex items-center gap-1"
        >
          <i className="bx bxs-bar-chart-alt-2 text-cyan-300 text-base sm:text-lg"></i>
          <span>Forecast: {signal.forecast}%</span>
        </InteractiveTooltip>

        <InteractiveTooltip
          explanation="نسبة الربح: العائد المئوي المتوقع من الصفقة"
          className="flex items-center gap-1"
        >
          <i className="bx bxs-dollar-circle text-cyan-300 text-base sm:text-lg"></i>
          <span>Payout: {signal.payout}%</span>
        </InteractiveTooltip>
      </div>
    </div>
  );
};

export default SignalCard;
